import type { IRecordTypeDefinition, ILocalizedText } from '@platform/core/types';

/**
 * Назва форми типу запису в «Налаштування › Форми» (прототип v4 `mm.singular + ' form'` через словник): «Форма «Справа»»; форми з
 * власним перекладом словника прототипу — `sysCust.formNames.<тип>` («Proposal form» — «Форма пропозиції»). Чиста функція.
 */
export function formTitle(rt: IRecordTypeDefinition, label: (text: ILocalizedText | null | undefined) => string,
  t: (key: string, vars?: Record<string, unknown>) => string): string {
  return t(`sysCust.formNames.${rt.key}`, { defaultValue: '' }) || t('sysCust.formOf', { name: label(rt.singular ?? rt.name) });
}
